export default __webpack_public_path__ + "static/media/SansWeb-Light.6445ed82.woff2";